import React, { useState, useEffect } from "react";
import "./SliderSection.scss";

import img1 from '../../../assets/image/Data-System-Infrastructure.jpg'
import img2 from '../../../assets/image/serveolence.jpg'
import img3 from '../../../assets/image/server.jpg'
import img4 from '../../../assets/image/server.jpg'
import img5 from '../../../assets/image/switch.png'
import img6 from '../../../assets/image/securitycameras-1.jpg'

const slides = [
  {
    id: 1,
    image: img1
  },
  {
    id: 2,
    image: img2
  },
  {
    id: 3,
    image: img3
  },
  {
    id: 4,
    image:img4
  },
  {
    id: 5,
    image:img5
  },
  {
    id: 6,
    image:img6
  },
];

export default function SliderSection() {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + length) % length);
  };

  // Auto-play
  useEffect(() => {
    const id = setInterval(nextSlide, 5000); // 5s
    return () => clearInterval(id);
  }, []);

  if (!Array.isArray(slides) || length === 0) return null;

  return (
    <section className="hero-slider">
      <button
        className="hero-slider__arrow hero-slider__arrow--left"
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        ❮
      </button>

      <button
        className="hero-slider__arrow hero-slider__arrow--right"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        ❯
      </button>

      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slider__slide ${
            index === current ? "is-active" : ""
          }`}
          style={{ backgroundImage: `url(${slide.image})` }}
        />
      ))}
    </section>
  );
}
